import React, { useContext, useEffect } from "react";
// import Progress from "../Progress";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import { AppContext } from "../../contexts/AppContext.jsx";
import {
  getLivenessStatus,
  verifyArs,
  updateApplication,
  submitApplication,
} from "../../Services/applicationService.jsx";
import { AlreadySubmittedError } from "../../Utils/Errors.tsx";
import Loader from "../Loader/Loader.jsx";
import { useNavigate } from "react-router-dom";
import ExternalLink from "../ExternalLink/ExternalLink.tsx";

function checkPassport(issueDate, birthDate) {
  const [iy, im, id] = issueDate.split("-").map(Number);
  const [by, bm, bd] = birthDate.split("-").map(Number);

  // Condition 1: Issued before 2004
  if (iy < 2004) {
    return true;
  }

  // Calculate age at the time of issue
  let age = iy - by;
  if (im < bm || (im === bm && id < bd)) {
    age--; // hasn't had birthday yet
  }

  // Condition 2: Age less than 12
  if (age < 12) {
    return true;
  }

  return false;
}

const PostLiveCheck = ({ handleNext, handleCancel, handleBack }) => {
  const { appState, setAppState, userFlows } = useContext(AppContext);
  const [livenessLink, setLivenessLink] = React.useState("");
  const [validating, setValidating] = React.useState(false);
  const [showRefree, setShowRefree] = React.useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setValidating(true);
    console.log("Submitting form...");
    if (livenessLink) {
      console.log(
        "Liveness link is available, proceeding to update application..."
      );
      updateApp();
    } else {
      console.error("Liveness link is not available, cannot proceed.");

      updateApp();
      // setValidating(false);
    }
  };
  
  const updateApp = () => {
    const updatedAppState = {
      ...appState,
      requestPayload: {
        ...appState.requestPayload,
        applicant: {
          ...appState.requestPayload.applicant,
        },
        liveness: {
          livenessLink: livenessLink || "token",
          livenessResult: true,
          livenessStatusCode: 100000002,
        },
      },
    };
    // console.log("Updated Application State:", updatedAppState);
    if (updatedAppState.requestPayload.applicationId) {
      updateApplication(updatedAppState.requestPayload)
        .then((response) => {
          
          console.log("Application updated successfully:", response);
          setAppState(updatedAppState);
          if (showRefree) {
            navigate("/app/pre-referee");
            setValidating(false);
            return;
          }
          
          submitApplication({
            serviceId: appState.requestPayload.applicationId,
          })
            .then((resp) => {
              console.log("Application submitted successfully:", resp);

              setValidating(false);
              navigate("/app/application-submit", { replace: true });
            })
            .catch((error) => {
              setValidating(false);
              if (!(error instanceof AlreadySubmittedError)) {
                navigate("/app/something-went-wrong");
              }
            });
        })
        .catch((error) => {
          setValidating(false);
          if (!(error instanceof AlreadySubmittedError)) {
            navigate("/app/something-went-wrong");
          }
        });
    }
  };

  useEffect(() => {
    getLivenessStatus()
      .then((response) => {
        console.log("Liveness status fetched successfully:", response);
        setLivenessLink(response.liveness_resource_url);
      })
      .catch((error) => {
        console.error("Error fetching liveness status:", error);
      });
  }, []);

  useEffect(() => {
    const id = appState?.requestPayload?.eventTypeSearch?.[0]?.eventTypeId;

    const validIds = [
      "b9294e90-bcd5-ee11-904c-000d3acb9d09",
      "7ee2df54-a934-ed11-9db1-0022489412bc",
      "700a9fae-a634-ed11-9db1-0022489412bc",
    ];

    console.log(validIds.includes(id), id);

    if (validIds.includes(id) || userFlows?.showRefree) {
      // your logic here
      console.log("Valid eventTypeId detected:", id);
      setShowRefree(true);
    }
  }, []);

  useEffect(() => {
    console.log("PostLiveCheck component mounted");

    const eventData = appState?.requestPayload?.eventTypeSearch?.[0];
    if (eventData.eventTypeId === "527c00ad-5756-ed11-9562-002248941c78") {
      const vFormData = {
        arsId: eventData.documentNumber,
        register: "passport",
        givenName: eventData.givenNames,
        familyName: eventData.familyName,
        dateOfBirth: eventData.dateOfBirth,
      };
      verifyArs(vFormData, navigate)
        .then((resp) => {
          if (
            checkPassport(resp?.person?.dateIssued, resp?.person?.date_of_birth)
          ) {
            setShowRefree(true);
          }
          setValidating(false);
        })
        .catch((error) => {
          console.error("Error verifying ARS:", error);
          setValidating(false);
        });
    }
  }, []);

  return (
    <>
      {validating && <Loader />}
      <div className="intro no-min-height">
        {/* <Progress progress={40} /> */}
        <h1 className="intro-title-mi" lang="mi-NZ">
          Ngā mihi, kua oti i a koe te hāpono whakaahua
        </h1>
        <hr />
        <h1 className="intro-title">
          Thanks, you've completed photo verification
        </h1>

        <div className="step-container">
          {showRefree ? (
            <>
              <p className="mb-4">
                We're now reviewing your photo to check it matches other records we may have of you.
              </p>
              <p className="mb-4">
                You can access the photo you've just taken once your verified identity has been approved.
              </p>
            </>
          ) : (
            <p className="mb-4">Your application is ready to be submitted.</p>
          )}
        </div>
      </div>

      <div className="step-button-container spacer-64">
        <SubmitButton
          text={!showRefree ? "Submit" : "Save and continue"}
          onClick={(e) => handleSubmit(e)}
        />
      </div>
    </>
  );
};

export default PostLiveCheck;
